import { render, staticRenderFns } from "./City.vue?vue&type=template&id=508a9fb7&scoped=true"
import script from "./City.vue?vue&type=script&lang=js"
export * from "./City.vue?vue&type=script&lang=js"
import style0 from "./City.vue?vue&type=style&index=0&id=508a9fb7&prod&scoped=true&lang=css"
import style1 from "./City.vue?vue&type=style&index=1&id=508a9fb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a9fb7",
  null
  
)

export default component.exports